// The project detail page serves all of these from ONE component instance
// (vue-router reuses it when two records render the same component), so the
// edit session, its staged changes and its history survive moving between
// them. See sessionSurvivesNavigation in the detail page.
export const PROJECT_BROWSER_ROUTE_NAMES = new Set([
  'projects-detail-art-item',
])

export const PROJECT_DETAIL_ROUTE_NAMES = new Set([
  'projects-detail',
  'projects-item-detail',
  ...PROJECT_BROWSER_ROUTE_NAMES,
])

export function isWithinProjectDetailNavigation(to, from) {
  return PROJECT_DETAIL_ROUTE_NAMES.has(to?.name)
    && PROJECT_DETAIL_ROUTE_NAMES.has(from?.name)
    && (to?.name !== 'projects-detail' || from?.name !== 'projects-detail')
    && String(to.params?.id ?? '') === String(from.params?.id ?? '')
}

export function projectBrowserItemRoute(projectId, itemId, currentQuery = {}) {
  const query = { ...currentQuery }
  delete query.tab
  delete query.item
  delete query.workspace
  return {
    name: 'projects-detail-art-item',
    params: { id: String(projectId), artId: String(itemId) },
    query,
  }
}

export function projectArtRoute(projectId, currentQuery = {}) {
  const query = { ...currentQuery }
  delete query.tab
  delete query.item
  delete query.workspace
  return {
    name: 'projects-detail',
    params: { id: String(projectId) },
    query,
  }
}

// Reordering a workspace-filtered board only returns that visible subset.
// Replace the subset's slots in the full project order without disturbing
// items hidden by the filter.
export function mergeFilteredItemOrder(allIds, filteredOrder) {
  const filtered = new Set(filteredOrder)
  let index = 0
  return allIds.map(id => filtered.has(id) ? filteredOrder[index++] : id)
}
